<template>
  <div>
    <div class="page page__list">
      <search-bar
        @search="onSearch"
        name="aql_code"
        placeholder="输入单据编号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/quality/qcaql/' + item.id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.aql_code }}</p>
            <p class="list-item-muted">{{ item.aql_name }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>默认-{{ item.aql_default ? '是' :'否' }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.aql_status != '已审核' }"
              >{{ item.aql_status }}</span
            >
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}笔</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/qcaql/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            }
          ],
        },
      ],
    };
  }
};
</script>